<style scoped lang="scss">
.call_dialog {
  position: fixed;
  left: 50%;
  margin-left: -175px;
  top: 300px;
  width: 350px;
}

.call_mask {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.footer {
  li {
    width: 50%;
    height: 40px;

    &:last-child {
      border-left: 1px solid #cccccc;
    }
  }

  border-top: 1px solid #cccccc;
}
</style>

<template>
  <div class="call" v-if="showTag">
    <div class="call_mask"></div>
    <div class="call_dialog flex column bg_fff">
      <div class="flex1 pl30 pr30 pt30 pb30">
        <audio id="audio" preload="auto" loop
               src="http://nethos-webtest.diandianys.com/download/mp3.mp3"></audio>
        <!--<el-image src="http://wx.hztywl.cn/gjhlwyy/static/img/doctor.m.png"
                  style="width: 50px;height: 50px;border-radius: 50%"></el-image>-->
        <!--<div class="ml20">
            <h4 class="fs16">{{info.senderName}}&lt;!&ndash; {{info.userType|userTypeName}}&ndash;&gt;</h4>
            <p class="fs12 color_main mt5">请求与您视频通话</p>
        </div>-->
        <h3 class="flex jcc">{{ info.senderName }}</h3>
        <p class="jcc flex mt10">{{ info.senderHosName }}</p>
      </div>
      <ul class="footer bg_fff flex0 flex">
        <li class="color_red flex aic jcc pointer" @click="hide"><span class="iconfont icon-guaduan"></span>拒绝
        </li>
        <li class="color_main flex aic jcc pointer" @click="toDetail(info)"><span
            class="iconfont icon-weibiaoti"></span>接受
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {staffService} from "../service/staff";
import {USER_TYPE} from "../../../common/lib/config";
import {callHushiActionCache} from "../../../common/lib/cache/callHushiAction";

export default {
  name: "call-dialog",
  filters: {
    userTypeName(str) {
      if (!str) return '';
      //return (USER_TYPE[str] && USER_TYPE[str].name) || str;
      if (str === 'AID_ADM') return USER_TYPE[str].name;
      return '';
    }
  },
  data() {
    return {
      info: {},
      showTag: false
    }
  },

  created() {
  },
  mounted() {
  },
  methods: {
    djsHide() {
      this.timer = setTimeout(() => {
        this.hide();
      }, 120000)
    },
    show(data) {
      this.info = data;
      this.showTag = true;
      this.$nextTick().then(() => {
        this.play();
        this.djsHide();
      });
    },
    hide() {
      this.stop();
      if (this.timer) clearTimeout(this.timer);
      this.timer = null;
      this.showTag = false;
    },
    stop() {
      const audioEl = document.getElementById('audio');
      if (audioEl) {
        audioEl.pause();
      }
    },
    play() {
      const audioEl = document.getElementById('audio');
      if (audioEl) {
        if (audioEl.paused && audioEl.readyState === 4) {
          audioEl.play();
        } else {
          setTimeout(() => {
            this.play()
          }, 100)
        }
      } else {
        setTimeout(() => {
          this.play()
        }, 100)
      }
    },
    async toDetail(data) {
      this.hide();
      //this.notify.close();
      const {loginInfo} = this;
      if (data.type === 'EMERGENCY') {
        const {initHosId} = await staffService.detailOrder(data.id);
        let aspectUser;
        if (initHosId === loginInfo.hosId) {
          aspectUser = 'init';
        } else {
          aspectUser = 'accept';
        }
        callHushiActionCache.set(1);
        this.$router.push({
          path: '/staff/detail',
          query: {id: data.id, aspectUser, action: 'callhushi', t: new Date().getTime()}
        })
      }
    },
  },
}
</script>
